import React from "react"
import { BadgeCheckIcon } from "@heroicons/react/solid"

/** Blue badge used when a community has claimed its listing (email on file). */
export default function CommunityVerifiedBadge({ className }) {
  return (
    <BadgeCheckIcon
      className={className}
      aria-label="Claimed listing on Hive Index"
      title="This community has claimed its listing on Hive Index"
    />
  )
}
